import { useAppStore } from "@/pinia/app";
import { computed, onMounted, Ref, watch } from "vue";

export function usePageTitle(pageName: Ref<string>) {
  const applicationStore = useAppStore();
  const pageTitle = computed(() => {
    if (!pageName.value) return "Almanac+";
    else return pageName.value;
  });
  watch(pageTitle, (val) => {
    applicationStore.pageName = val || "";
  });

  onMounted(() => {
    applicationStore.pageName = pageName.value || "";
  });

  return {
    pageTitle,
  };
}
